"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ExclamationMarkTCircle16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00001 0V8H9.00001V0H7.00001ZM12.8797 1.58457L13.5944 2.28397C15.1223 3.77907 16 5.81807 16 7.99544C16 12.4117 12.4188 15.9909 8 15.9909C3.58254 15.9909 0 12.411 0 7.99544C0 5.92265 0.801996 3.97632 2.20456 2.5009L2.41942 2.28316L3.13496 1.58458L4.53211 3.01565L3.81658 3.71423C2.66141 4.84203 2 6.36576 2 7.99544C2 11.3061 4.68677 13.9909 8 13.9909C11.3145 13.9909 14 11.3069 14 7.99544C14 6.45825 13.4182 5.01629 12.393 3.91572L12.1956 3.71342L11.4809 3.01402L12.8797 1.58457ZM7.00001 12V10H9.00001V12H7.00001Z", fill: "#383F49" }));
}
function ExclamationMarkTCircle16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ExclamationMarkTCircle16Svg, Object.assign({}, svgProps)));
}
exports.default = ExclamationMarkTCircle16;
//# sourceMappingURL=ExclamationMarkTCircle16.js.map